// extracted by mini-css-extract-plugin
export var checkboxInputRow = "v_sH";
export var checkboxInputColumn = "v_sJ";
export var inputOptionRow = "v_qN";
export var inputOptionColumn = "v_qP";